module.exports = __webpack_public_path__ + "img/dt.da2ab10c.jpg";